import ErrorPage from "@/components/pages/ErrorPage";
import { ConsentCompleteView } from "@/features/consent/components/ConsentCompleteView";
import { loadConsentCompletePage } from "@/features/consent/utils/consentCompleteLoader";
import { createFileRoute } from "@tanstack/react-router";

function PatientConsentCompletePage() {
    const { consentId, diaryId } = Route.useParams();

    return <ConsentCompleteView consentId={consentId} diaryId={diaryId} routeContext="patients" />;
}

export const Route = createFileRoute("/_app/patients/$diaryId/consent/$consentId/complete")({
    component: PatientConsentCompletePage,
    errorComponent: ({ error, reset }) => <ErrorPage error={error as Error} reset={reset} />,
    loader: async ({ context: { queryClient, auth }, params }) =>
        loadConsentCompletePage({
            queryClient,
            consentId: params.consentId,
            diaryId: params.diaryId,
            userId: auth?.id,
            routeContext: "patients",
            invalidRedirect: {
                to: "/patients/$diaryId",
                params: { diaryId: params.diaryId },
            },
        }),
});
